import {Component} from "react";
import AppAddIcon from "../../media/app-images/AppAddIcon.mjs";
import {Button, Input, InputGroup, InputGroupText, Label} from "reactstrap";
import MySelect from "../../controls/MySelect/MySelect.mjs";
import TextLabel from "../../controls/TextLabel/TextLabel.mjs";
import TrashIcon from "../../media/images/TrashIcon.mjs";
import CheckIcon from "../../media/images/CheckIcon.mjs";
import "./AssociazioniStrategicheSoggetto.css";
import Glob from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix = 'AssociazioniStrategicheSoggetto';

const AssociazioniStrategicheSoggetto = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.asso.value,
			showAllItems: false
		}
		this.uid = Glob.generateUid(prefix);
		this.add = this.add.bind(this);
		this.getName = this.getName.bind(this);
		this.edit = this.edit.bind(this);
		this.boot = this.boot.bind(this);
	}
	add() {
		const asso = this.state.value || [];
		asso.push( this.state.adding );
		this.props.save( asso );
	}
	getName( i ) {
		for( const group of this.state.options ) {
			for ( const option of group.options ) {
				if ( option.value === i ) return option.label;
			}
		}
		return i;
	}
	componentDidMount() {
		this.boot();
	}
	async boot() {
		const ns = { ready: true };
		let needAll = false;
		if ( this.state.value && this.state.value.length > 0 ) {
			this.state.value.forEach( v => {
				if ( needAll ) return;
				if ( ! this.props.asso.options.some( group => group.options.some( option => option.value === v.item ) ) ) needAll = true;
			})
		}
		ns.forceAllItems = needAll;
		if ( needAll || this.state.showAllItems ) {
			if ( ! this.state.all ) {
				ns.all = await appLib.strategicOptions();
				for ( const group of ns.all ) {
					const ogrp = this.props.asso.options.find( g => g.label === group.label )?.options || [];
					for ( const option of group.options ) {
						if ( ! ogrp.some( o => o.value === option.value ) ) option.label += ' [Extra]';
					}
				}
			}
			ns.showAllItems = true;
			ns.options = this.state.all ?? ns.all;
		} else {
			ns.options = this.props.asso.options;
		}
		this.setState(ns);
	}
	edit(i) {
		const value = this.state.value;
		const adding = value.splice(i,1)[0];
		this.setState({ adding: adding, value: value });
	}
	render() {
		const a = this.props.asso;
		if ( ! this.state.ready ) return null;
		return(
			<div key={a.id} className={prefix}>
				<h6>
					<span>{ a.name }</span>
					<span
						style={{cursor: "pointer"}}
						onClick={ ()=>{ this.setState({ adding: { weight: .25 } })}}
						role="button"
						hidden={ this.state.adding}
					>
						<AppAddIcon />
					</span>
				</h6>
				<p className={"checkSelector"}>
					<Input
						id={ this.uid + '-chk'}
						type="checkbox"
						checked={ !! this.state.showAllItems }
						disabled={ !! this.state.forceAllItems }
						onChange={ ( c ) => {
							this.setState( { showAllItems: c.target.checked }, this.boot );
						} }
					/>
					<Label htmlFor={ this.uid + '-chk'}>
						Mappato al di fuori di: { (this.props.asso.settori_acn || ['—'].join(', ')) }
					</Label>
				</p>
				{ this.state.value.map( (v,i) => (
					<div key={v.item}>
						<tt>{ Math.round(v.weight * 10000) / 100 }%</tt>
						<strong
							style={this.state.adding ? null : { cursor: "pointer" }}
							onClick={ ()=>{ if ( ! this.state.adding ) this.edit( i )}}
						>
							{ this.getName(v.item) }
						</strong>
					</div>
				)) }
				{ this.state.adding && (
					<InputGroup className={"adding"}>
						<div className={"flex-grow-1"}>
							<MySelect
								options={ this.state.options }
								isClearable={ true }
								placeholder={ Glob.label(this.state.showAllItems ? 'Select whatever item' : 'Select an appropriate item')}
								value={ this.state.adding.item ? { value: this.state.adding.item, label: this.getName(this.state.adding.item) } : null }
								onChange={ x => {
									const adding = this.state.adding;
									adding.item = x?.value;
									this.setState({ adding: adding });
								}}
							/>
						</div>
						<InputGroupText>
							<TextLabel value={"Weight"} /> %:
						</InputGroupText>
						<Input
							style={{maxWidth: "100px"}}
							type="number"
							min={0}
							max={100}
							value={ Number(this.state.adding?.weight||0) * 100 }
							onChange={ e => {
								let adding = this.state.adding;
								adding.weight = e.target.value / 100;
								this.setState({ adding: adding });
							}}
						/>
						<Button
							color={"danger"}
							onClick={ ()=>{
								this.setState({adding:false}, ()=>{
									this.props.save( this.state.value );
								});
							}}
						>
							<TrashIcon />
						</Button>
						<Button
							color={"success"}
							disabled={ ! ( this.state.adding?.item && this.state.adding.weight ) }
							onClick={ this.add }
						>
							<CheckIcon />
						</Button>
					</InputGroup>
				)}
			</div>
		)
	}
}

export default AssociazioniStrategicheSoggetto;